import i18n from "i18next";
import Modal from "@/Components/Modals/Modal";
import ValidationErrors from "@/Components/ValidationErrors";
import {FormInput, PhoneOrEmailInput} from "@/Components/Controls";
import React from "react";
import {useForm} from "@inertiajs/inertia-react";
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";

export default function EditProfileModal({props, state, dispatch}) {

    const { data, setData, post, processing, errors } = useForm({
        first_name: props.auth.user.first_name,
        last_name: props.auth.user.last_name,
        email: props.auth.user.email,
        phone: props.auth.user.phone,
        redirect: false,
    });

    const canSelfEdit = props.auth.user.can.canSelfEdit;

    const onChange = (event, value) => {
        setData(event, value);
    };

    const editProfileSave = (e) => {
        e.preventDefault();

        post(route('manage.profile.store')
            ,
            {
                onSuccess: () => dispatch({ type: "editProfileModal", payload: { editProfileModal: false }})
            }
        );
    };

    return (
        <Modal isOpen={state.editProfileModal}
               title={i18n.t("admin-account-overview.edit-profile-modal.edit-my-profile")}
               id="unity"
               dialogClassName="edit-dialog"
               modalClassName="edit-modal"
               dataTestid="admin_account_overview_edit_profile-modal"
               setIsOpen={() => dispatch({ type: "editProfileModal", payload: { editProfileModal: false}})}>
            <div className="modal-body">
                <form onSubmit={editProfileSave} id="edit-profile-form">
                    <div className="slider-body">
                        {false && <ValidationErrors errors={errors} />}
                        <div className="row">
                            <FormInput dataTestid="my_profile_first_name-input" error={errors["first_name"]} name="first_name" isFocused={true} autoComplete="first_name" value={data.first_name} onChange={onChange} label={i18n.t("my-profile-slider.first-name")} className="col-12" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            <FormInput dataTestid="my_profile_last_name-input"  error={errors["last_name"]} name="last_name" autoComplete="last_name" value={data.last_name} onChange={onChange} label={i18n.t("my-profile-slider.last-name")} className="col-12" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            <FormInput dataTestid="my_profile_email-input" error={errors["email"]} name="email" autoComplete="email" value={data.email} onChange={onChange} label={i18n.t("my-profile-slider.email")} className="col-12" disabled={!canSelfEdit} />
                        </div>
                        <div className="row">
                            <PhoneOrEmailInput dataTestid="my_profile_phone-input" error={errors["phone"]} name="phone" autoComplete="phone" value={data.phone} onChange={onChange} label={i18n.t("my-profile-slider.phone")} className="col-12" disabled={!canSelfEdit} />
                        </div>
                    </div>
                    <div className="modal-actions">
                        <ButtonBorderless dataTestid="admin_account_overview_edit_profile-modal-cancel-button" className="modal-cancel" onClick={() => dispatch({ type: "editProfileModal", payload: { editProfileModal: false}})}>
                            {i18n.t("admin-account-overview.cancel")}
                        </ButtonBorderless>
                        <ButtonPrimary dataTestid="admin_account_overview-edit_profile-modal-save-button" type="submit" processing={processing} disabled={processing} >
                            {i18n.t("admin-account-overview.save")}
                        </ButtonPrimary>
                    </div>
                </form>
            </div>
        </Modal>
    )
}
